export const COOKIE_NEXT_LOCALE = 'NEXT_LOCALE';
export const COOKIE_AUTH_TOKEN = 'thkn92aETh3SpLrEWtVd';
